module.exports = __webpack_public_path__ + "img/de.e5476a0d.svg";